import _suggestCloseCircleLine from "@zenlayer/zen-design-icons/assets/suggest/CloseCircleLine.svg";
import _generalCalendar from "@zenlayer/zen-design-icons/assets/general/Calendar.svg";
import { useControllableValue } from 'ahooks';
import { DatePicker as AntdDatePickerForDayjs } from 'antd';
import classNames from 'classnames';
import React, { useEffect, useState } from 'react';
import { getDefaultFormat } from '../_util/day';
import { error } from '../_util/devConsoleLog';
import Chips from '../chips';
import { useConfig } from '../hooks/useConfig';
import Icon from '../icon';
import Space from '../space';
import Tag from '../tag';
import TextField from '../text-field';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// -----------AntdDatePickerForDayjs-----------
// import generatePicker from 'antd/es/date-picker/generatePicker';
// import 'antd/es/date-picker/style/index';
// import { Dayjs } from 'dayjs';
// import dayjsGenerateConfig from 'rc-picker/es/generate/dayjs';

// const AntdDatePickerForDayjs = generatePicker<Dayjs>(dayjsGenerateConfig);
// -----------AntdDatePickerForDayjs-----------

const DatePicker = props => {
  var _ref, _ref2;
  const {
    label,
    placeholder,
    type = 'outline',
    size = 'm',
    disabled,
    disabledDate,
    allowClear,
    width,
    rangePicker = false,
    picker = 'date',
    ranges,
    presets,
    defaultValue,
    value: propsValue,
    onChange: propsOnChange,
    timeZone,
    prefixClass = 'zen-design',
    //TODO 写provider时统一改掉
    className,
    style,
    ...restProps
  } = props;
  const {
    locale: {
      DatePicker: DatePickerLocale
    }
  } = useConfig();
  const baseClassName = "".concat(prefixClass, "-datePicker");
  const [value, onChange] = useControllableValue(props, {
    defaultValue: undefined,
    defaultValuePropName: 'defaultValue',
    valuePropName: 'value',
    trigger: 'onChange'
  });
  const [shrink, setShrink] = useState(false);
  const [isFocus, setFocus] = useState(false);
  const canDoSomething = !disabled;
  useEffect(() => {
    if (isFocus) {
      setShrink(true);
    } else {
      if (value === undefined || JSON.stringify(value) === '[]') {
        setShrink(false);
      } else {
        setShrink(true);
      }
    }
  }, [value, isFocus]);
  const prefixIcon = /*#__PURE__*/_jsx(Icon, {
    type: "general/Calendar"
  });
  useEffect(() => {
    error(label !== undefined && placeholder !== undefined, 'DatePicker', "'label' and 'placeholder' cannot be shared.");
  }, []);
  const allowClearIcon = allowClear && value !== undefined ? /*#__PURE__*/_jsx(Icon, {
    type: "suggest/CloseCircleLine",
    block: true,
    onClick: () => {
      onChange(undefined);
    },
    style: {
      cursor: 'pointer'
    }
  }) : undefined;
  const timeZoneIcon = timeZone ? /*#__PURE__*/_jsx(Tag, {
    size: "s",
    block: true,
    children: timeZone
  }) : undefined;
  const suffixIcon = timeZoneIcon || allowClearIcon ? /*#__PURE__*/_jsxs(Space, {
    style: {
      zIndex: 2
    },
    children: [timeZoneIcon, allowClearIcon]
  }) : undefined;
  const customProps = {
    popupClassName: "".concat(baseClassName, "-dropdown"),
    variant: 'borderless',
    allowClear: false,
    suffixIcon: false,
    disabled,
    format: getDefaultFormat(picker, typeof restProps.showTime === 'object' ? restProps.showTime.showSecond === false || restProps.showTime.format === 'HH:mm' ? 'HM' : 'HMS' : !!restProps.showTime),
    picker,
    presets: presets !== null && presets !== void 0 ? presets : Object.entries(ranges || {}).map(i => ({
      label: i[0],
      value: i[1]
    })),
    value,
    onChange,
    onFocus: e => {
      setFocus(true);
      canDoSomething && shrink === false && setShrink(true);
    },
    onBlur: () => {
      setFocus(false);
      value === undefined && shrink === true && setShrink(false);
    },
    ...restProps
  };
  const DatePickerRender = rangePicker ? /*#__PURE__*/_jsx(AntdDatePickerForDayjs.RangePicker, {
    className: classNames("content", {
      ["".concat(size)]: !!size,
      ["shrink"]: !!shrink,
      ["with-prefixIcon"]: !!true,
      ["with-suffixIcon"]: !!allowClear
    }),
    placeholder: (_ref = placeholder) !== null && _ref !== void 0 ? _ref : ['', ''],
    locale: DatePickerLocale,
    disabledDate: disabledDate,
    ...customProps
  }) : /*#__PURE__*/_jsx(AntdDatePickerForDayjs, {
    className: classNames("content", {
      ["".concat(size)]: !!size,
      ["with-prefixIcon"]: !!true,
      ["with-suffixIcon"]: !!allowClear
    }),
    placeholder: (_ref2 = placeholder) !== null && _ref2 !== void 0 ? _ref2 : '',
    locale: DatePickerLocale,
    disabledDate: disabledDate,
    ...customProps
  });
  if (label === undefined) {
    return /*#__PURE__*/_jsx(Chips, {
      size: size,
      type: type,
      disabled: disabled,
      prefix: prefixIcon,
      suffix: suffixIcon,
      width: width,
      style: style,
      className: classNames(className, "".concat(baseClassName, "-forChips")),
      children: DatePickerRender
    });
  }
  return /*#__PURE__*/_jsx(TextField, {
    label: label,
    type: type,
    shrink: shrink,
    isFocus: isFocus,
    size: size,
    disabled: disabled,
    prefix: prefixIcon,
    suffix: suffixIcon,
    width: width,
    style: style,
    className: classNames(className, baseClassName),
    children: DatePickerRender
  });
};
export default DatePicker;